import { z } from 'zod';
import { CustomErrorParams, CustomErrorType, DateService, DateTimeUtils, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { MAX_DAY_DIFFERENCE } from './constants';

export enum FilterFormKeys {
    dateFrom = 'dateFrom',
    dateTo = 'dateTo',
    swedishIntegrationId = 'swedishIntegrationId',
    cashRegisterId = 'cashRegisterId',
}

// Export the search schema for use in the route
export const swedishFiscalReportSearchSchema = z.object({
    [FilterFormKeys.dateFrom]: Validation.Date.Iso.optional(),
    [FilterFormKeys.dateTo]: Validation.Date.Iso.optional(),
    [FilterFormKeys.swedishIntegrationId]: z.string().uuid().optional(),
    [FilterFormKeys.cashRegisterId]: z.string().optional(),
});

// Schema for default values validation (required fields)
export const defaultFilterSchema = z
    .object({
        [FilterFormKeys.dateFrom]: Validation.Date.Iso,
        [FilterFormKeys.dateTo]: Validation.Date.Iso,
        [FilterFormKeys.swedishIntegrationId]: z.string().uuid(),
        [FilterFormKeys.cashRegisterId]: z.string(),
    })
    .refine(
        (data) => {
            // Ensure MAX_DAY_DIFFERENCE is respected
            const diffInDays = DateService.diffDates(
                DateTimeUtils.dateIsoStringToDate(data[FilterFormKeys.dateTo]),
                DateTimeUtils.dateIsoStringToDate(data[FilterFormKeys.dateFrom])
            );
            if (diffInDays < 0) {
                return false;
            }
            return diffInDays <= MAX_DAY_DIFFERENCE;
        },
        {
            path: [FilterFormKeys.dateTo],
            params: {
                errorType: CustomErrorType.Other,
                textKey: TextKey.ValidateDateRangeMaxDifferenceDays,
                substitutes: {
                    maxDifferenceDays: MAX_DAY_DIFFERENCE,
                },
            } satisfies CustomErrorParams,
        }
    );

export type FilterFormValues = z.infer<typeof defaultFilterSchema>;
